"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowTextTooltip = exports.default = exports.BOTTOM = exports.TOP = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./tooltip.sass");

var _Portal = _interopRequireDefault(require("../Portal"));

var _getScrollBarWidth = _interopRequireWildcard(require("../_utils/getScrollBarWidth"));

var TOP = 'top';
exports.TOP = TOP;
var BOTTOM = 'bottom';
exports.BOTTOM = BOTTOM;
var LEFT = 'left';
var RIGHT = 'right';
var CENTER = 'center';

var Tooltip =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Tooltip, _PureComponent);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(Tooltip).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      isVisible: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleRef", function (element) {
      if (!element) {
        return;
      }

      _this.element = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseEnter", function () {
      _this.setState({
        isVisible: !!_this.props.tooltip
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "orientation", function () {
      var orientation = _this.props.orientation;

      if (_this.isOutTheScreen) {
        switch (orientation) {
          case TOP:
            return BOTTOM;

          case BOTTOM:
            return TOP;
        }
      }

      return orientation;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onMouseLeave", function () {
      if (_this.state.isVisible) {
        _this.setState({
          isVisible: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPosition", function () {
      if (!_this.element) {
        return null;
      }

      var tooltip = _this.props.tooltip;

      var _this$createFakeToolt = _this.createFakeTooltip(tooltip || _this.state.tooltip),
          fakeContainer = _this$createFakeToolt.fakeContainer,
          fakeBubble = _this$createFakeToolt.fakeBubble;

      _this.setupFakeContainer(fakeContainer);

      _this.element.appendChild(fakeContainer);

      var verticalPosition = _this.getVerticalPosition(fakeContainer);

      var horizontalPosition = _this.getHorizontalPosition(fakeBubble);

      var verticalOrientation = _this.getOrientation(fakeContainer);

      var horizontalOrientation = _this.getHorizontalOrientation(fakeBubble);

      _this.element.removeChild(fakeContainer);

      return {
        position: (0, _objectSpread2.default)({}, verticalPosition, horizontalPosition),
        verticalOrientation: verticalOrientation,
        horizontalOrientation: horizontalOrientation
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "createFakeTooltip", function (tooltip) {
      var fakeContainer = document.createElement('div');
      var fakeBubble = document.createElement('span');
      fakeBubble.textContent = tooltip;
      fakeContainer.appendChild(fakeBubble);
      return {
        fakeBubble: fakeBubble,
        fakeContainer: fakeContainer
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setupFakeContainer", function (fakeContainer) {
      var orientation = _this.props.orientation;

      var _this$element$getBoun = _this.element.getBoundingClientRect(),
          elementRight = _this$element$getBoun.right,
          elementWidth = _this$element$getBoun.width,
          elementBottom = _this$element$getBoun.bottom,
          elementTop = _this$element$getBoun.top;

      var verticalStyle;

      switch (orientation) {
        case TOP:
          verticalStyle = "bottom: ".concat(window.innerHeight - elementTop, "px");
          break;

        case BOTTOM:
        default:
          verticalStyle = "top: ".concat(elementBottom, "px");
          break;
      }

      fakeContainer.classList.add('tooltip-container', 'tooltip-container--centered');
      fakeContainer.style = "\n            left: ".concat(elementRight - elementWidth / 2, "px;\n            ").concat(verticalStyle, ";\n            visibility:hidden\n        ");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getVerticalPosition", function (fakeContainer) {
      var orientation = _this.props.orientation;
      var verticalPosition = {};

      var _fakeContainer$getBou = fakeContainer.getBoundingClientRect(),
          fakeContainerTop = _fakeContainer$getBou.top,
          fakeContainerBottom = _fakeContainer$getBou.bottom;

      var _this$element$getBoun2 = _this.element.getBoundingClientRect(),
          elementBottom = _this$element$getBoun2.bottom,
          elementTop = _this$element$getBoun2.top;

      if (orientation === TOP) {
        if (fakeContainerTop < 0) {
          verticalPosition.top = elementBottom;
        } else {
          verticalPosition.bottom = window.innerHeight - elementTop;
        }
      } else if (orientation === BOTTOM) {
        if (fakeContainerBottom > window.innerHeight) {
          verticalPosition.bottom = window.innerHeight - elementTop;
        } else {
          verticalPosition.top = elementBottom;
        }
      }

      return verticalPosition;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOrientation", function (fakeContainer) {
      var orientation = _this.props.orientation;

      var _fakeContainer$getBou2 = fakeContainer.getBoundingClientRect(),
          fakeContainerTop = _fakeContainer$getBou2.top,
          fakeContainerBottom = _fakeContainer$getBou2.bottom;

      switch (true) {
        case orientation === TOP:
          return fakeContainerTop < 0 ? BOTTOM : TOP;

        case orientation === BOTTOM:
          return fakeContainerBottom > window.innerHeight ? TOP : BOTTOM;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getHorizontalPosition", function (fakeBubble) {
      var horizontalPosition = {};

      var _fakeBubble$getBoundi = fakeBubble.getBoundingClientRect(),
          fakeBubbleLeft = _fakeBubble$getBoundi.left,
          fakeBubbleRight = _fakeBubble$getBoundi.right;

      var _this$element$getBoun3 = _this.element.getBoundingClientRect(),
          elementLeft = _this$element$getBoun3.left,
          elementRight = _this$element$getBoun3.right,
          elementWidth = _this$element$getBoun3.width;

      if (fakeBubbleLeft < 0) {
        horizontalPosition.left = elementLeft;
      } else if (fakeBubbleRight >= window.innerWidth) {
        var right = (0, _getScrollBarWidth.hasScrollbar)() ? window.innerWidth - elementRight - (0, _getScrollBarWidth.default)() : window.innerWidth - elementRight;
        horizontalPosition.right = right;
      } else {
        horizontalPosition.left = elementRight - elementWidth / 2;
      }

      return horizontalPosition;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getHorizontalOrientation", function (fakeBubble) {
      var _fakeBubble$getBoundi2 = fakeBubble.getBoundingClientRect(),
          fakeBubbleLeft = _fakeBubble$getBoundi2.left,
          fakeBubbleRight = _fakeBubble$getBoundi2.right;

      var outOfLeft = fakeBubbleLeft < 0;
      var outOfRight = fakeBubbleRight > window.innerWidth;

      switch (true) {
        case !outOfLeft && !outOfRight:
          return CENTER;

        case outOfRight:
          return RIGHT;

        case outOfLeft:
          return LEFT;

        default:
          return CENTER;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getArrowPosition", function (orientation) {
      var _this$element$getBoun4 = _this.element.getBoundingClientRect(),
          left = _this$element$getBoun4.left,
          top = _this$element$getBoun4.top,
          bottom = _this$element$getBoun4.bottom,
          width = _this$element$getBoun4.width;

      var position = {
        left: left + width / 2
      };

      if (orientation === TOP) {
        position.top = top - 4;
      } else {
        position.top = bottom;
      }

      return position;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderTooltip", function () {
      var tooltip = _this.props.tooltip;

      var _this$getPosition = _this.getPosition(),
          position = _this$getPosition.position,
          verticalOrientation = _this$getPosition.verticalOrientation,
          horizontalOrientation = _this$getPosition.horizontalOrientation;

      var arrowPosition = _this.getArrowPosition(verticalOrientation);

      var containerClass = (0, _classnames.default)('tooltip-container', {
        'tooltip-container--visible': _this.state.isVisible,
        'tooltip-container--centered': horizontalOrientation === CENTER,
        'tooltip-container--right': horizontalOrientation === RIGHT,
        'tooltip-container--left': horizontalOrientation === LEFT
      });
      var arrowClassName = (0, _classnames.default)('tooltip-arrow', {
        'tooltip-arrow--visible': _this.state.isVisible,
        'tooltip-arrow--top': verticalOrientation === TOP
      });
      return _react.default.createElement(_Portal.default, null, _react.default.createElement("div", {
        className: containerClass,
        style: position
      }, _react.default.createElement("span", {
        className: arrowClassName,
        style: arrowPosition
      }), _react.default.createElement("span", {
        className: "tooltip-bubble"
      }, tooltip || _this.state.tooltip)));
    });
    window.addEventListener('resize', _this.onMouseLeave);
    window.addEventListener('scroll', _this.onMouseLeave);
    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onMouseLeave);
      window.removeEventListener('scroll', this.onMouseLeave);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          inline = _this$props.inline,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["className", "children", "inline"]);
      props.className = (0, _classnames.default)('tooltip', className, {
        'tooltip--inline': !!inline
      });
      return _react.default.createElement("div", (0, _extends2.default)({}, props, {
        ref: this.handleRef,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }), children, this.state.isVisible && this.renderTooltip());
    }
  }]);
  return Tooltip;
}(_react.PureComponent);

exports.default = Tooltip;
(0, _defineProperty2.default)(Tooltip, "defaultProps", {
  orientation: BOTTOM
});
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.any,
  tooltip: _propTypes.default.node,
  inline: _propTypes.default.bool,
  orientation: _propTypes.default.oneOf([TOP, BOTTOM])
} : {};

var OverflowTextTooltip =
/*#__PURE__*/
function (_Tooltip) {
  (0, _inherits2.default)(OverflowTextTooltip, _Tooltip);

  function OverflowTextTooltip() {
    var _getPrototypeOf2;

    var _this2;

    (0, _classCallCheck2.default)(this, OverflowTextTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(OverflowTextTooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "onMouseEnter", function (e) {
      if (!_this2.element || _this2.element.scrollWidth <= _this2.element.offsetWidth) {
        return;
      }

      var tooltip = _this2.element.innerHTML.replace(/<\/?[^>]+(>|$)/g, ' ').trim();

      _this2.setState({
        tooltip: tooltip,
        isVisible: !!tooltip
      });
    });
    return _this2;
  }

  return OverflowTextTooltip;
}(Tooltip);

exports.OverflowTextTooltip = OverflowTextTooltip;